
import React, { useRef, useState } from "react";

import { ContentContainer } from "../../components/content-container/ContentContainer";
import { ContentSection } from "../../components/content-section/ContentSection";
import { ContentView } from "../../components/content-view/ContentView";
import ContextualAppBar from "../../components/contextual-app-bar/ContextualAppBar";
import { ViewOptionStateEnum } from "../../components/contextual-app-bar/ViewOptionStateEnum";


import { ActionMenuItem } from "../../components/action-menu/ActionMenuItem";
import CustomFormInstanceList, { CustomFormInstanceListType } from "../../components/custom-form-instance-list/CustomFormInstanceList";

export default function ObjectFormView() {

    const [viewOptionState, setViewOptionState] = useState(ViewOptionStateEnum.Default);
    const [actions, setActions] = useState<ActionMenuItem[]>([]);

    const customFormList = useRef<CustomFormInstanceListType>(undefined);

    function onExecuteAction(action: ActionMenuItem) {
        customFormList?.current?.executeAction(action);
    }

     return (
        <ContentView>

            <ContentContainer>
                <ContentSection>
                    <ContextualAppBar
                        actions={actions}
                        onExecuteAction={onExecuteAction}
                        viewOptionState={viewOptionState}
                    />

                    <CustomFormInstanceList 
                        setViewOptionState={setViewOptionState}
                        setActions={setActions}
                        ref={customFormList}/>

                </ContentSection>

            </ContentContainer>

        </ContentView>
    );
 
}